import { defineComponent as _defineComponent } from 'vue'
import { Client, ClientOnboardingStatus } from 'ah-api-gateways';
import StatusPill from 'ah-common-lib/src/common/components/StatusPill.vue';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientOnboardingStatusPill',
  props: {
  client: {
    type: Object as PropType<Client>,
    required: true,
  },
},
  setup(__props) {



const STATUS_COLORS: Record<ClientOnboardingStatus, string> = {
  [ClientOnboardingStatus.CREATED]: 'grey',
  [ClientOnboardingStatus.PENDING]: 'warning',
  [ClientOnboardingStatus.APPROVED]: 'success',
  [ClientOnboardingStatus.REJECTED]: 'danger',
};

const STATUS_LABELS: Record<ClientOnboardingStatus, string> = {
  [ClientOnboardingStatus.CREATED]: 'Info required',
  [ClientOnboardingStatus.PENDING]: 'In-review',
  [ClientOnboardingStatus.APPROVED]: 'Approved',
  [ClientOnboardingStatus.REJECTED]: 'Rejected',
};

return { __sfc: true,STATUS_COLORS, STATUS_LABELS, StatusPill }
}

})